import React from 'react';

import hoistNonReactStatics from 'hoist-non-react-statics';


export default (mediaQueries, defaultValue = false, injectAsProp = false) => WrappedComponent => hoistNonReactStatics(
  class WithMediaQueries extends React.PureComponent {
    static displayName = `WithMediaQueries(${WrappedComponent.displayName || WrappedComponent.name})`;

    constructor(props) {
      super(props);

      this.state = injectAsProp ? {[injectAsProp]: defaultValue} : defaultValue;
    }

    updateMatches = () => {
      const matches = Object.keys(this._mediaQueryList).reduce((acc, key) => {
        acc[key] = this._mediaQueryList[key].matches;

        return acc;
      }, {});


      this.setState(injectAsProp ? {[injectAsProp]: matches} : matches);
    };

    componentDidMount() {
      if (!window.matchMedia) {
        return;
      }

      this._mediaQueryList = Object.keys(mediaQueries).reduce((acc, key) => {
        const mq = window.matchMedia(mediaQueries[key]);
        mq.addListener(this.updateMatches);

        acc[key] = mq;
        return acc;
      }, {});

      this.updateMatches();
    }

    componentWillUnmount() {
      if (!this._mediaQueryList) {
        return;
      }

      Object.values(this._mediaQueryList).forEach(mq => mq.removeListener(this.updateMatches));
    }

    render() {
      return <WrappedComponent {...this.props} {...this.state}/>;
    }
  }
, WrappedComponent)



// WEBPACK FOOTER //
// ./containers/withMediaQueries/withMediaQueries.js